import React from 'react';
import TaxiAppCloneCostCard from './taxi-app-clone-cost-card';

const TaxiAppCloneCost = () => {
    return (
        <div className="section-py dark:bg-black bg-grey">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="text-center lg:col-span-10 lg:col-start-2 pb-50">
                        <h2 className="text-primary mb-2.5" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            How Much The Taxi Clone App Will Cost Finally?
                        </h2>
                        <p className="fw-400 mb-0 fs-md fs-mdlg" data-aos="fade-up" data-aos-duration="700" data-aos-delay="200">
                            Actually, the fact is that it is very difficult to provide an accurate quote for developing a mobile
                            taxi app. It depends on what technological platform, framework, and features you choose to include in
                            your application. Do not forget that you will have to build two separate apps; one for the driver and
                            another for the user. According to Moweb, the prime factors to consider when developing your taxi
                            mobile app are as follows:
                        </p>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-4 lg:grid-cols-4 md:grid-cols-4 mx-auto">
                    <TaxiAppCloneCostCard
                        text=" Mobile Platform - Android or iOS"
                        path={'/img/icons/ic-mobile-platform.svg'}
                        alt="on-demand taxi booking"
                        width={64}
                        height={64}
                    />
                    <TaxiAppCloneCostCard
                        text="Hybrid or Native
            App"
                        path={'/img/icons/ic-hybrid-native-app.svg'}
                        alt="on-demand taxi booking"
                        width={64}
                        height={64}
                    />
                    <TaxiAppCloneCostCard
                        text="The Design of the
            UI & UX"
                        path={'/img/icons/ic-ui-ux.svg'}
                        alt="on-demand taxi booking"
                        width={64}
                        height={64}
                    />
                    <TaxiAppCloneCostCard
                        text="Web Development"
                        path={'/img/icons/ic-backend-development.svg'}
                        alt="on-demand taxi booking"
                        width={64}
                        height={64}
                    />
                    <TaxiAppCloneCostCard
                        text="The Backend Development"
                        path={'/img/icons/ic-backend-development.svg'}
                        alt="on-demand taxi booking"
                        width={64}
                        height={64}
                    />
                    <TaxiAppCloneCostCard
                        text="Adding the Security
            Features"
                        path={'/img/icons/ic-adding-security-features.svg'}
                        alt="on-demand taxi booking"
                        width={64}
                        height={64}
                    />
                    <TaxiAppCloneCostCard
                        text="Project Management"
                        path={'/img/icons/ic-project-management.svg'}
                        alt="on-demand taxi booking"
                        width={64}
                        height={64}
                    />
                    <TaxiAppCloneCostCard
                        text="QA and Maintenance"
                        path={'/img/icons/ic-qa-maintenance.svg'}
                        alt="on-demand taxi booking"
                        width={64}
                        height={64}
                    />
                </div>
            </div>
        </div>
    );
};

export default TaxiAppCloneCost;
